import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Select from 'antd/lib/select';
import { accountRegistrationStatusesT } from '../../../../common/enums';

const { Option } = Select;

const RegistrationStatus = ({ t, value, onChange }) => {
  return (
    <Select placeholder={t('Vybrať stav')} onChange={onChange} value={value}>
      <Option value="">{t('Všetky stavy')}</Option>
      {Object.entries(accountRegistrationStatusesT).map(([key, value]) => (
        <Option key={key} value={key}>
          {value}
        </Option>
      ))}
    </Select>
  );
};

RegistrationStatus.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RegistrationStatus.defaultProps = {
  value: '',
};

export default translate()(RegistrationStatus);



// WEBPACK FOOTER //
// ./src/features/account-management/components/filters/RegistrationStatus.js